export enum StakeType {
  LIQUID = "liquid",
  NATIVE = "native",
}
